module.exports = __webpack_public_path__ + "media/src/assets/Images/Abitab-177d7f33ea0200acbbb245c4d8e4a67e.svg";